import { FC, useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Autoplay } from 'swiper/core';
import DialogDetailContainer from '../../../components/dialog-detail-container';
import FixedRightTools from '../../../components/fixed-right-tools';

import 'swiper/swiper.less';
import './style.less';

SwiperCore.use([Autoplay]);

interface IProps {
	classNames?: string;
}
const CourseTab: FC<IProps> = (props) => {
	const { classNames } = props;
	const [activeTab, setActiveTab] = useState<number | string>(1);
	const [detailVisible, setDetailVisible] = useState<boolean>(false);
	const [detailInfo, setDetailInfo] = useState<any>();
	const swipeRef = useRef(null);

	const onSlidePrev = () => {
		swipeRef.current?.slidePrev?.();
	};

	const onSlideNext = () => {
		swipeRef.current?.slideNext?.();
	};

	const getSwipeInstance = (swiper) => {
		swipeRef.current = swiper;
	};

	const courseList1 = [
		{
			courseImg:
				'https://img.qlchat.com/qlLive/activity/image/92MN91OF-C55H-M6ZB-1712487029323-FFJ3PKX9VD9P.png?x-oss-process=image/format,webp',
			title: '4天气血调理体验营',
			desc: '75438人正在学',
			detailImg: '',
			imgList: [
				'https://img.qlchat.com/qlLive/activity/image/7MELUB2G-19CO-GPM1-1712476959609-NT44QVH57D8M.jpg',
				'https://img.qlchat.com/qlLive/activity/image/G8VQE5MV-9UPN-FXA9-1712476965844-SY4RMDLYULIB.jpg',
				'https://img.qlchat.com/qlLive/activity/image/R6J7VPJR-SZSQ-MC7G-1712476967137-B6MIIS3PLEB4.jpg',
				'https://img.qlchat.com/qlLive/activity/image/MSQCTQ3M-GPMQ-CQ48-1712476968745-TLI2RVUU329D.jpg',
				'https://img.qlchat.com/qlLive/activity/image/27Y5CU9J-KQQ2-KZ64-1712476970554-KEMBXXBDG1PK.jpg',
				'https://img.qlchat.com/qlLive/activity/image/GEFQBVVA-94ZV-2XCZ-1712476972177-NTH75KZ5H8HW.jpg',
				'https://img.qlchat.com/qlLive/activity/image/6ZQ4TGL9-FSGY-KXT3-1712476973946-63XLVN6VI9GA.jpg',
				'https://img.qlchat.com/qlLive/activity/image/OT17VXBI-4KWD-Y5UJ-1712476975754-LP1DKHYRQC7Y.jpg',
				'https://img.qlchat.com/qlLive/activity/image/QYNO972C-OMOO-JRQS-1712476977482-U5E6QJDCKPXZ.jpg',
				'https://img.qlchat.com/qlLive/activity/image/P3C4IW8I-L6IZ-PUDR-1712476979481-DRDKFRXB122J.jpg',
				'https://img.qlchat.com/qlLive/activity/image/V4F3QCBA-X8W8-HKOE-1712476981017-EL27RJZI39RM.jpg',
				'https://img.qlchat.com/qlLive/activity/image/676HMKEA-LSVG-IO8G-1712476982327-WOEAZOE53LG5.jpg',
				'https://img.qlchat.com/qlLive/activity/image/4H7KYCFX-PGV9-FWFE-1712476983825-O2V6K6OU5TTZ.jpg',
				'https://img.qlchat.com/qlLive/activity/image/OF293EI7-M3F9-SHB4-1712476985489-GHX5RESQKGD3.jpg',
				'https://img.qlchat.com/qlLive/activity/image/YER69JSI-SDRN-JPDM-1712561270995-8MUPIOJXWRZ9.png',
			],
			tags: ['调息降火·脸色红润', '舒筋活络·调补气血'],
		},
		{
			courseImg:
				'https://img.qlchat.com/qlLive/activity/image/T2F5ZVVZ-HM89-RG4U-1712475563789-KP6FW865ODIX.png?x-oss-process=image/format,webp',
			title: '居家健康5天养生营',
			desc: '62832人正在学',
			detailImg:
				'https://img.qlchat.com/qlLive/activity/image/FQ7K9E2T-ACWU-4PJW-1712475567342-68TYGCNQYE2O.jpg',
			tags: ['吃出好体质', '养出好气色'],
		},
		{
			courseImg:
				'https://img.qlchat.com/qlLive/activity/image/GA2NCJQY-FASK-IWL7-1712486974972-UFGH1DFK9LXE.png?x-oss-process=image/format,webp',
			title: '5天普拉提美体营',
			desc: '736293人正在学',
			detailImg: '',
			imgList: [
				'https://img.qlchat.com/qlLive/activity/image/2K3TADAU-65OW-JI8P-1712476473199-5DO5QGDL6S7Q.jpg',
				'https://img.qlchat.com/qlLive/activity/image/EDNMGDBK-MCHP-MDTF-1712476475971-PYD4NCBN1ZN6.jpg',
				'https://img.qlchat.com/qlLive/activity/image/2JSLJTO4-EKYG-QUFS-1712476481987-PEL47H74UZ6C.gif',
				'https://img.qlchat.com/qlLive/activity/image/4NKAWQFT-6IWP-J7UG-1712476483906-3O17SVINSXBJ.jpg',
				'https://img.qlchat.com/qlLive/activity/image/WXLGK25L-LTOU-UAWA-1712476485762-57CYVFL63EA8.gif',
				'https://img.qlchat.com/qlLive/activity/image/Z8T2FUU6-SOFQ-GUNR-1712476487626-YFGSFCUTFETX.jpg',
				'https://img.qlchat.com/qlLive/activity/image/N13BJOR3-W7NC-5Q7I-1712476489441-NCV1YWIIJ63B.jpg',
				'https://img.qlchat.com/qlLive/activity/image/7Z7YQA5E-AGN3-VG8D-1712476491210-HXCKVBJLFLF5.jpg',
				'https://img.qlchat.com/qlLive/activity/image/T1PJ66X1-KRZJ-EKPN-1712476493138-EAZO7UC4I8YU.jpg',
				'https://img.qlchat.com/qlLive/activity/image/I8DUAQ7E-WFVK-1P3X-1712476494769-X81O3PMDWSMI.jpg',
				'https://img.qlchat.com/qlLive/activity/image/QY6XF335-4869-PIOV-1712476496289-W931ZE2GPXA3.jpg',
				'https://img.qlchat.com/qlLive/activity/image/L6T6KJP1-J724-VEMJ-1712476497858-99NRJ6TLVEOC.jpg',
				'https://img.qlchat.com/qlLive/activity/image/A8MD4WPH-QCQ1-TV4X-1712476499730-YHEAOOAAT8VO.jpg',
				'https://img.qlchat.com/qlLive/activity/image/4KFLNU7R-KUGS-1C2E-1712476501699-PAO24WPBTUAT.jpg',
				'https://img.qlchat.com/qlLive/activity/image/4VTWKMC4-1JK7-UUSZ-1712476503819-G83E9L2G3ZW2.jpg',
			],
			tags: ['不跑不跳轻松练'],
		},
		{
			courseImg:
				'https://img.qlchat.com/qlLive/activity/image/MZ7LE6ZR-3N2Q-XYDL-1709639032579-P76PVYIVLOAZ.png?x-oss-process=image/format,webp',
			title: '华佗五禽戏脏腑养生营',
			desc: '38713人正在学',
			detailImg: '',
			imgList: [
				'https://img.qlchat.com/qlLive/activity/image/T8JGLVPE-JJED-KUXM-1712477142113-3G9ZGEEJHU7V.png',
				'https://img.qlchat.com/qlLive/activity/image/3YOADONW-RBGK-O68M-1712477144323-OWMWZRADX1NA.png',
				'https://img.qlchat.com/qlLive/activity/image/SKIS45K9-KG4M-M3AD-1712477145730-BE3FTDJA9WAW.png',
				'https://img.qlchat.com/qlLive/activity/image/RFN9AYXW-9B52-XKET-1712477146962-YHJ6Z21DCGKX.png',
				'https://img.qlchat.com/qlLive/activity/image/RIQ5L7WZ-KCMW-SKYA-1712477151118-W1TIGCRT2QNV.jpg',
				'https://img.qlchat.com/qlLive/activity/image/ZH31HOI1-HWWN-3B7P-1712477152842-7CESJ8PKCEEO.png',
				'https://img.qlchat.com/qlLive/activity/image/EKGJ6VCY-VD7Q-JLDC-1712477154594-WD43RAG8IWIG.png',
				'https://img.qlchat.com/qlLive/activity/image/98B4EXIT-PEZI-QTSO-1712477155883-XCVTB4VF43VV.png',
				'https://img.qlchat.com/qlLive/activity/image/W4W14WQ7-M1AI-YU8C-1712477157313-XWSGLZWUAMJJ.png',
				'https://img.qlchat.com/qlLive/activity/image/YPDIYKAW-ATQY-EUL6-1712477158602-5GZOIJL3SY8E.png',
				'https://img.qlchat.com/qlLive/activity/image/4HFH2LVG-4N3X-AMC2-1712477160058-FJIIXZ2HYGEP.png',
			],
			tags: ['华佗秘传', '祛湿扶阳养神开慧'],
		},
	];
	const courseList2 = [
		{
			courseImg:
				'https://img.qlchat.com/qlLive/activity/image/ZFJCVIPR-PSOI-XVYY-1709640927086-HR3V2URQXJNG.png?x-oss-process=image/format,webp',
			title: '4天女神蜕变体验营',
			desc: '43927人正在学',
			detailImg: '',
			imgList: [
				'https://img.qlchat.com/qlLive/activity/image/L5VEN8YF-813A-B76E-1712475297120-VJ7ZFOX2W3A2.jpg',
				'https://img.qlchat.com/qlLive/activity/image/UUQF7YST-QLRV-1F9E-1712475300302-PYHJYXO72E5E.jpg',
				'https://img.qlchat.com/qlLive/activity/image/SRYT4B13-GE4Q-JFQU-1712475303142-ZO3JNYEVN8SC.jpg',
				'https://img.qlchat.com/qlLive/activity/image/EUASB1X4-HOB8-3XYG-1712475305878-CBMVANHOLQEF.jpg',
				'https://img.qlchat.com/qlLive/activity/image/4OPTZDCH-F9N2-UGYW-1712475308365-JVRBW25Q2M8Z.jpg',
				'https://img.qlchat.com/qlLive/activity/image/YZRS849D-73NB-OO77-1712475311653-8NDFMV6WV17X.jpg',
				'https://img.qlchat.com/qlLive/activity/image/DRDTP59B-M5TF-N68N-1712475314636-JHSDECDZLGZW.jpg',
				'https://img.qlchat.com/qlLive/activity/image/MMGWW7RK-2NLU-J6BZ-1712475317087-J7FSY4RURYIE.jpg',
				'https://img.qlchat.com/qlLive/activity/image/QWQ922W2-TFY5-O4NS-1712475319502-5MIHZM566E91.jpg',
				'https://img.qlchat.com/qlLive/activity/image/OCENKSAS-Y2YZ-4CBA-1712475322247-HNEFZTEFX896.jpg',
				'https://img.qlchat.com/qlLive/activity/image/AF18Q33X-85H4-UGHV-1712475324637-FXHK9TVEHG5B.jpg',
				'https://img.qlchat.com/qlLive/activity/image/GYNAI2IF-Z2G6-35CJ-1712475327359-G3BQ1BUKAB7B.jpg',
				'https://img.qlchat.com/qlLive/activity/image/BUVG7CPO-GPR1-2EX9-1712475329637-F7A634VBFP84.jpg',
			],
			tags: ['科学有效变瘦变好看', '穿出高级感'],
		},
		{
			courseImg:
				'https://img.qlchat.com/qlLive/activity/image/IMQIQQL2-6XP5-5PPH-1712486839960-VWKUO96DNXDQ.jpg?x-oss-process=image/format,webp',
			title: '5天帮你轻松躺瘦3-5斤',
			desc: '8762人正在学',
			detailImg: '',
			imgList: [
				'https://img.qlchat.com/qlLive/activity/image/HNYSLOH8-ZEZ1-GWYI-1712475854601-IT2CBC8ZV1V9.jpg',
				'https://img.qlchat.com/qlLive/activity/image/BF952FXL-A8CO-BMU4-1712475867737-UCFTPZOJKU37.jpg',
				'https://img.qlchat.com/qlLive/activity/image/14SEO23P-JDIP-ABKM-1712475869618-UTYHYM5QTFS2.jpg',
				'https://img.qlchat.com/qlLive/activity/image/6FS3ZO3T-KSVC-URMP-1712475871297-EL5FBPTZAKGY.jpg',
				'https://img.qlchat.com/qlLive/activity/image/OV5LDRBH-3JCQ-L3JG-1712475872882-FBM5RMLU3DHZ.jpg',
				'https://img.qlchat.com/qlLive/activity/image/SMS2NJLW-3HAT-7PIF-1712475875050-LFOVS55J1TPW.jpg',
				'https://img.qlchat.com/qlLive/activity/image/S7BBWKRW-XSN8-G7MO-1712475876633-MPW6W8SCTK94.gif',
				'https://img.qlchat.com/qlLive/activity/image/EI74AF2G-O5VP-E9WW-1712475878442-MH3PLUVI9ECC.jpg',
				'https://img.qlchat.com/qlLive/activity/image/RGDI5DMG-PX26-Y7LC-1712475880106-YF8NTKNET1G3.jpg',
				'https://img.qlchat.com/qlLive/activity/image/FQB914L4-BE9I-AFZL-1712475881809-BT86AR5YATKS.jpg',
				'https://img.qlchat.com/qlLive/activity/image/D2JYE5IT-USNO-LE1U-1712475883745-ZP2WTJC122MI.jpg',
				'https://img.qlchat.com/qlLive/activity/image/9143IX6R-CGHN-IXI8-1712475885323-DLZPSOHEXN7V.jpg',
				'https://img.qlchat.com/qlLive/activity/image/A1VELBPT-YQFH-Q9LK-1712475887058-EACEX3MVHPVQ.jpg',
				'https://img.qlchat.com/qlLive/activity/image/YAA5QY17-YRDH-4VQJ-1712475889362-JN44BU8VCCWL.jpg',
				'https://img.qlchat.com/qlLive/activity/image/2FWLRSFJ-26UZ-R2SN-1712475903142-NDQYW4DZZBE2.jpg',
				'https://img.qlchat.com/qlLive/activity/image/RJ8ZTRWF-87I3-ASTW-1712475904817-2BAJ2VBEOYZV.jpg',
			],
			tags: ['顿顿吃饱也能瘦', '国际营养师'],
		},
		{
			courseImg:
				'https://img.qlchat.com/qlLive/activity/image/EVN2U55M-AN15-JP6A-1709641027616-G6VWVHFS3XOR.png?x-oss-process=image/format,webp',
			title: '4天手机摄影风光小白营',
			desc: '26265人正在学',
			detailImg:
				'https://img.qlchat.com/qlLive/activity/image/UCH7RU9O-FYO9-9ST8-1709642820699-4OU6C8PUFRIL.png',
			tags: ['轻松拍出朋友圈靓照', '优质圈子共同学习'],
		},
	];
	const courseList3 = [
		{
			courseImg:
				'https://img.qlchat.com/qlLive/activity/image/G1WCYSHN-A352-BAF3-1712481999980-3AVK2X8ZHV11.jpg?x-oss-process=image/format,webp',
			title: '5天减压静心禅舞营',
			desc: '8238人正在学',
			detailImg: '',
			imgList: [
				'https://img.qlchat.com/qlLive/activity/image/ATYJTF5T-YCW2-6YQC-1712474185420-SXZ8OA7FBN9O.jpg',
				'https://img.qlchat.com/qlLive/activity/image/ZNBYCRHB-KDA7-CU3K-1712474203780-D35LSMCDD7JH.jpg',
				'https://img.qlchat.com/qlLive/activity/image/EW8CTAMZ-DLAA-7Q1C-1712474205777-WVS8RNM9J7KQ.jpg',
				'https://img.qlchat.com/qlLive/activity/image/4G7QHDIF-HOWU-4IER-1712474208233-79JP9DBB2BGW.jpg',
				'https://img.qlchat.com/qlLive/activity/image/W9JKN9U9-5D77-UN23-1712474210449-YK73B63KYMS7.jpg',
				'https://img.qlchat.com/qlLive/activity/image/AHR73SO2-A8N2-JI1V-1712474212497-HQFWWC5EBGYX.jpg',
				'https://img.qlchat.com/qlLive/activity/image/GSM5PKQD-E6JC-PXX8-1712474222849-GTMQWZ5N3TWO.jpg',
				'https://img.qlchat.com/qlLive/activity/image/YTS5O5LK-UX27-QKM6-1712474226536-R556H8VZ64O7.jpg',
				'https://img.qlchat.com/qlLive/activity/image/K9J5HO81-QA2U-8YIP-1712474229442-2WPWDU988323.jpg',
				'https://img.qlchat.com/qlLive/activity/image/SYMODGH3-8AGN-ZPIA-1712474232140-EN6JAASR2A21.jpg',
				'https://img.qlchat.com/qlLive/activity/image/KAZZQJBP-1IXQ-DFJ3-1712474234785-IXQOPJU159RW.jpg',
				'https://img.qlchat.com/qlLive/activity/image/I59KAHFV-3A97-HUVH-1712474237457-3NY4NEX6ZVTA.jpg',
				'https://img.qlchat.com/qlLive/activity/image/36TBIWJP-INVV-VHHK-1712474240249-TY9LHBPQ9RR3.jpg',
				'https://img.qlchat.com/qlLive/activity/image/J4P95YOC-9VZ8-9UZ8-1712474243041-7ZOUDXZNOXKW.jpg',
			],
			tags: ['人人皆可舞，越跳越健康快乐'],
		},
		{
			courseImg:
				'https://img.qlchat.com/qlLive/activity/image/6X7G1S47-QP72-38TY-1709798511214-W829GOMVAHED.png?x-oss-process=image/format,webp',
			title: '4天身体唱歌体验营',
			desc: '7882人正在学',
			detailImg:
				'https://img.qlchat.com/qlLive/activity/image/1RJ3M5VW-AQO3-KAE8-1712487335890-AVJM7OIFCP2W.gif',
			tags: ['不练嗓子，只练身体就能唱好歌'],
		},
	];
	const courseList4 = [
		{
			courseImg:
				'https://img.qlchat.com/qlLive/activity/image/L71WIH1T-V1FE-IO5V-1712487241150-ZR9MNJFIG2M3.png?x-oss-process=image/format,webp',
			title: '探秘占星师占星训练营',
			desc: '23781人正在学',
			detailImg:
				'https://img.qlchat.com/qlLive/activity/image/FKZC2FE5-A1VC-ZUTJ-1712487233196-27OXQHL7H3IX.png?x-oss-process=image/format,webp',
			tags: ['预测推算·万事顺利'],
		},
		{
			courseImg:
				'https://img.qlchat.com/qlLive/activity/image/CM9IBFH9-H8MD-ZBLN-1712487164196-GIKR9OD4FIHY.jpg?x-oss-process=image/format,webp',
			title: '4天国学易经实战营',
			desc: '7166人正在学',
			detailImg: '',
			imgList: [
				'https://img.qlchat.com/qlLive/activity/image/JV34EYVV-HA6D-3OIT-1712477427442-4SLWJ4DVS9G2.jpg',
				'https://img.qlchat.com/qlLive/activity/image/IT3J8AVQ-KVGE-3KNS-1712477429133-SVA2CABYM7K2.jpg',
				'https://img.qlchat.com/qlLive/activity/image/KSJV8F4C-GRVG-F29H-1712477430761-SSWPJTFTVE8U.jpg',
				'https://img.qlchat.com/qlLive/activity/image/WAIYX4UB-CQKJ-FBSV-1712477432133-V3VYEHQMOA7Q.jpg',
				'https://img.qlchat.com/qlLive/activity/image/ALIVNPR6-156L-PCOO-1712477433649-BUWGVAW14Q9Q.jpg',
				'https://img.qlchat.com/qlLive/activity/image/FJYHZ9QJ-7X1Z-HLI2-1712477435090-VT9G3FCQ3KCS.jpg',
				'https://img.qlchat.com/qlLive/activity/image/ACRISB9T-EQMS-OR5H-1712477436641-51KSH7GAAR4Y.jpg',
				'https://img.qlchat.com/qlLive/activity/image/HRFG4OYG-KGM1-UQIL-1712477438297-W57YDLFVK4Z5.jpg',
				'https://img.qlchat.com/qlLive/activity/image/9MVWSGC8-Y7AJ-48K4-1712477440257-UM3ENPQVXPNH.jpg',
				'https://img.qlchat.com/qlLive/activity/image/9MJM3NLW-DOI5-27WJ-1712477486717-UXQJSDFZJWNA.jpg',
				'https://img.qlchat.com/qlLive/activity/image/25AXG1WV-DK2B-NZC5-1712477490131-ILBS6J116WQK.jpg',
			],
			tags: ['解析运势', '解锁命盘', '趋吉避凶'],
		},
	];

	const tabList = [
		{
			category: '健康',
			value: 1,
			courseList: courseList1,
		},
		{
			category: '美学',
			value: 2,
			courseList: courseList2,
		},
		{
			category: '才艺',
			value: 3,
			courseList: courseList3,
		},
		// {
		// 	category: '心灵',
		// 	value: 4,
		// 	courseList: courseList4,
		// },
	];

	const showDetail = (item) => {
		setDetailInfo(item);
		setDetailVisible(true);
	};

	return (
		<div className={`more-courses-list-container ${classNames}`}>
			<div className="tab-list">
				{tabList.map((item) => {
					return (
						<div
							key={item.value}
							className={`tab-item ${activeTab === item.value ? 'active' : ''}`}
							onClick={() => setActiveTab(item.value)}
						>
							{item.category}
						</div>
					);
				})}
			</div>

			{tabList.map((item, idx) => {
				const hasMore = item.courseList.length > 2;

				return (
					activeTab === item.value && (
						<div key={idx} className="more-courses-list">
							{hasMore && (
								<>
									<div
										className="more-courses-prev flex-center"
										onClick={onSlidePrev}
									>
										<i className="iconfont iconxiaojiantou to-left"></i>
									</div>
									<div
										className="more-courses-next flex-center"
										onClick={onSlideNext}
									>
										<i className="iconfont iconxiaojiantou"></i>
									</div>
								</>
							)}
							<Swiper
								onSwiper={getSwipeInstance}
								// navigation={true}
								slidesPerView={2}
								loop={hasMore}
								observer
								observeParents
								observeSlideChildren
								spaceBetween={32}
								className="more-courses-swiper tab-fade-in"
							>
								{item.courseList?.map((item: any, index: number): any => (
									<SwiperSlide key={index} className="more-courses-slide">
										<div
											className="more-courses-item"
											key={index}
											onClick={() => showDetail(item)}
										>
											<img className="course-img" src={item?.courseImg} />
											<div className="flex-center jc-between">
												<div className="course-title">{item?.title}</div>
												<div className="course-desc">{item?.desc}</div>
											</div>
										</div>
									</SwiperSlide>
								))}
							</Swiper>
						</div>
					)
				);
			})}

			<DialogDetailContainer
				containerClass="dialog-more-course-tab-detail"
				changeVisible={() => setDetailVisible(false)}
				visible={detailVisible}
			>
				<div className="course-tab-detail">
					<div className="left-part">
						{detailInfo?.detailImg ? (
							<img className="course-intro" src={detailInfo?.detailImg} />
						) : (
							<div>
								{detailInfo?.imgList?.map((item, index) => (
									<img className="course-intro" key={index} src={item} />
								))}
							</div>
						)}
					</div>
					<div className="right-part">
						<div className="info">
							<div className="course-name">{detailInfo?.title}</div>
							<div className="course-desc">{detailInfo?.desc}</div>
							<div className="course-tag-wrap">
								{detailInfo?.tags?.map((item, idx) => {
									return (
										<div className="course-tag" key={idx}>
											{item}
										</div>
									);
								})}
							</div>
						</div>
						<div className="code-title">手机扫码下载app学习</div>
						<img
							className="qr-code"
							src="https://img.qlchat.com/qlLive/activity/image/KHGNAUUL-7X8Q-ZYF5-1709792495337-O1A5DSGEAPD8.png?x-oss-process=image/format,webp"
							alt="兴趣岛APP下载二维码"
						/>
					</div>
				</div>
			</DialogDetailContainer>
			<FixedRightTools />
		</div>
	);
};
export default CourseTab;
